import {ChangeDetectionStrategy, Component} from "@angular/core";
import {Base} from "../../../../../../common/interfaces/base.interfaces";

@Component({
    selector: "section-warehouse-order-closed-list",
    template: `
        <section-warehouse-order-list [state]="state" [status]="'closed'"
                                      header="Closed orders"></section-warehouse-order-list>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WarehouseOrderClosedListComponent implements Base.IComponent {


    public readonly state: Base.IState;

    public constructor() {
    }

    public ngConfig(): Base.IConfig {
        return {
            name: "warehouse-orders-closed",
            actions: {
                "browse": ["browse_warehouse_orders"]
            }
        };
    }

}
